import React from 'react';
import { Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { splitIntoLines } from '../../../../helpers/domHelper';

export const InboxesInfoModal: React.FC = () => {
  const { t } = useTranslation();
  const text = t('settings.inbox.info');
  return <Modal.Body>{splitIntoLines(text)}</Modal.Body>;
};

export default InboxesInfoModal;
